module.exports = __webpack_public_path__ + "static/media/Libson.708abff2.png";